// Register.js
import React, { useState } from "react";
import { registerUser } from "../services/apiService";
import { useNavigate } from "react-router-dom";

const Register = () => {
    const [form, setForm] = useState({ username: "", email: "", password: "", repassword: "" });
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (form.password !== form.repassword) {
            setError("Passwords do not match");
            return;
        }

        const res = await registerUser(form.username, form.email, form.password, form.repassword);
        if (res.success) {
            navigate("/login");
        } else {
            setError(res.error.message || "Registration failed");
        }
    };

    return (
        <div className="max-w-md mx-auto mt-20 text-white">
            <h2 className="text-2xl font-bold mb-4">Register</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                {["username", "email", "password", "repassword"].map((field) => (
                    <input
                        key={field}
                        type={field.includes("password") ? "password" : "text"}
                        name={field}
                        placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                        className="w-full p-2 bg-gray-800 border border-gray-600 rounded"
                        value={form[field]}
                        onChange={handleChange}
                        required
                    />
                ))}
                {error && <p className="text-red-400">{error}</p>}
                <button className="w-full bg-cyan-500 hover:bg-cyan-600 p-2 rounded text-white font-semibold">
                    Register
                </button>
            </form>
        </div>
    );
};

export default Register;
